// src/pages/Leads.jsx
import React, { useState, useEffect } from "react";
import LeadsExplorer from "../components/LeadsExplorer/LeadsExplorer";
import styles from "./Leads.module.scss";

function Leads() {
  const isDev = process.env.NODE_ENV === "development";
  const [isAuthenticated, setIsAuthenticated] = useState(isDev);
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [leads, setLeads] = useState([]);
  const [error, setError] = useState("");

  const API_URL = isDev
    ? "http://localhost/consumir_dev.php"
    : "/consumir.php";
  const AUTH_URL = isDev
    ? "http://localhost/auth_dev.php"
    : "/auth.php";

  // Login handler (sólo en producción)
  const handleLogin = async (e) => {
    e.preventDefault();
    try {
      const response = await fetch(AUTH_URL, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ username, password }),
      });
      const data = await response.json();
      if (data.success) {
        setIsAuthenticated(true);
        setError("");
      } else {
        setError(data.error || "Credenciales inválidas.");
      }
    } catch (err) {
      console.error(err);
      setError("Error de conexión.");
    }
  };

  // Carga de datos
  useEffect(() => {
    if (isDev) {
      import("../data/leadsData.json")
        .then((mod) => setLeads(mod.default || mod))
        .catch((err) => console.error("No se cargó leadsData.json", err));
    } else if (isAuthenticated) {
      fetch(API_URL)
        .then((res) => {
          if (!res.ok) throw new Error(`HTTP ${res.status}`);
          return res.json();
        })
        .then((data) => {
          console.log("API devolvió:", data);
          setLeads(data);
        })
        .catch((err) => {
          console.error(err);
          setError("Error al cargar los leads.");
        });
    }
  }, [isDev, isAuthenticated]);

  // Cambio de estado de un lead
  const updateLeadStatus = (id, newStatus) => {
    if (isDev) {
      setLeads((prev) =>
        prev.map((l) => (l.id === id ? { ...l, status: newStatus } : l))
      );
    } else {
      fetch(API_URL, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id, status: newStatus }),
      })
        .then(() =>
          setLeads((prev) =>
            prev.map((l) =>
              l.id === id ? { ...l, status: newStatus } : l
            )
          )
        )
        .catch((err) => console.error(err));
    }
  };

  // Si no está autenticado en producción, mostramos el login
  if (!isAuthenticated && !isDev) {
    return (
      <div className={styles.loginContainer}>
        <form onSubmit={handleLogin} className={styles.loginForm}>
          <h2 className={styles.loginTitle}>Iniciar sesión</h2>
          <input
            type="text"
            placeholder="Usuario"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            className={styles.loginInput}
          />
          <input
            type="password"
            placeholder="Contraseña"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className={styles.loginInput}
          />
          {error && <p className={styles.errorMessage}>{error}</p>}
          <button type="submit" className={styles.loginButton}>
            Ingresar
          </button>
        </form>
      </div>
    );
  }

  // Render principal
  return (
    <div className={styles.pageContainer}>
      <h1 className={styles.pageTitle}>Lista de Leads</h1>
      <LeadsExplorer
        leads={leads}
        updateLeadStatus={updateLeadStatus}
        formatDate={(ts) => {
          if (!ts) return "Fecha no disponible";
          const d = new Date(ts);
          return isNaN(d)
            ? "Fecha inválida"
            : `${String(d.getDate()).padStart(2, "0")}/${String(
                d.getMonth() + 1
              ).padStart(2, "0")}/${d.getFullYear()}`;
        }}
      />
    </div>
  );
}

export default Leads;
